import { useEffect } from 'react';
import { Box } from '@rsos/base-components';
import { trackStatusPageRender } from '../../../gainsightTrackings/airAmbulanceTrackings';
import { STATUS_PAGE_STATES } from '../AirAmbulanceForm/constants';
import { useExistingRequest } from '../AirAmbulanceForm/hooks/useExistingRequest';
import StatusBanner from '../Banner/StatusBanner';
import { getStatusState } from '../utils/statusUtils';
import AirAmbulanceStatusControls from './AirAmbulanceStatusControls';
import AirAmbulanceStatusTracking from './AirAmbulanceStatusTracking';
import AirAmbulanceStatusUpdates from './AirAmbulanceStatusUpdates';

const AirAmbulanceStatus = () => {
  const { existingRequest, existingRequestBody } = useExistingRequest();
  const isTimeout = existingRequest?.status === '408';
  const statuses = Array.isArray(existingRequestBody?.status)
    ? existingRequestBody.status
    : [];
  const statusState = getStatusState(
    existingRequestBody?.trip_data,
    statuses,
    isTimeout,
  );

  // Determine if we should show tracking component
  // Show tracking if we have any statuses OR if we have tracking data (brand_tail/tracking_url)
  const hasTrackingData =
    existingRequestBody?.brand_tail || existingRequestBody?.tracking_url;
  const hasAnyStatuses = statuses && statuses.length > 0;
  const shouldShowTracking =
    statusState !== STATUS_PAGE_STATES.SUBMITTED ||
    hasTrackingData ||
    hasAnyStatuses;

  useEffect(() => {
    trackStatusPageRender({
      requestId:
        existingRequestBody?.ext_trip_id || existingRequest?.request_id,
      status: statusState.value,
    });
  }, [
    existingRequest?.request_id,
    existingRequestBody?.ext_trip_id,
    statusState.value,
  ]);

  return (
    <Box>
      <Box m={1}>
        <StatusBanner showChevron={false} />
      </Box>

      {/* Show tracking when we have statuses, tracking data, or are not in submitted state */}
      {shouldShowTracking && <AirAmbulanceStatusTracking />}

      <AirAmbulanceStatusUpdates />
      <AirAmbulanceStatusControls />
    </Box>
  );
};

export default AirAmbulanceStatus;
